import React from "react";
import { Typography } from "@mui/material";

interface EventEHRImageAvatarProps {
  image?: any;
  commonStyle?: any;
  customCommonStyle?: any;
  customTextStyle?: any;
  labelText?: string;
  customImageStyle?: any;
  customOuterLabelStyle?: any;
}

const EventEHRImageAvatar = ({
  image = "",
  commonStyle = {
    width: "60px",
    height: "60px",
    objectFit: "cover",
    borderRadius: "6px",
    background: "teal",
    overflow: "overlay",
  },
  customImageStyle = {},
  customOuterLabelStyle = {},
  customTextStyle = {
    fontSize: "30px",
    fontWeight: "bold",
  },
  labelText = "NA",
}: EventEHRImageAvatarProps) => {
  const splittedLabel = labelText?.toUpperCase()?.split(" ");

  return (
    <div>
      {image && (
        <div style={{ ...commonStyle, ...customImageStyle }}>
          <img
            className="border-radius-6px"
            src={image}
            alt="profile-picture"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>
      )}
      {!image && (
        <div
          style={{ ...commonStyle, ...customOuterLabelStyle }}
          className="flex justify-center items-center"
        >
          <Typography style={{ ...customTextStyle }}>
            {splittedLabel?.length >= 2
              ? `${splittedLabel?.[0]?.charAt(0) + splittedLabel?.[1]?.charAt(0)}`
              : "NA"}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default EventEHRImageAvatar;
